/**
 * Stub functionality for client show and tell
 *
 */
class Search {

  constructor () {

    this.btnToggles = document.querySelectorAll('[data-toggle-search]');

    this.handleToggleClick = this.handleToggleClick.bind(this);
  }
  handleToggleClick () {
    window.location = '/search';
  }

  init () {
    if (this.btnToggles.length > 0) {
      this.btnToggles.forEach((btn) => {
        btn.addEventListener('click', this.handleToggleClick);
      });
    }
  }
}

export default Search;
